export interface Title {
  title: string;
  startDate: string;
  endDate: string;
}

export function rsltTypeInTitle(rsltType: string) {
  let title: string;
  switch (rsltType) {
    case "pesq":
    default:
      title = "VQT-PESQ Results";
      break;
    case "polqa":
      title = "VQT-POLQA Results";
      break;
    case "call-events":
      title = "Call Events";
      break;
    case "vba":
      title = "VBA-EModel Results";
      break;
    case "fax":
      title = "FAX Results";
      break;
    case "audio-delay":
      title = "Audio-Delay Measurements";
      break;
    case "emu":
      title = "EMU Results";
      break;
    case "nettest":
      title = "NetTest Results";
      break;
    case "mobileinfo":
      title = "MobileInfo Results";
      break;
    case "vac":
      title = "VAC Results";
      break;

    case "AudioDelayStatsPieChart":
      title = "Audio-Delay Statistics";
      break;
    case "VoiceQualityStatsPieChart":
      title = "Voice Quality Statistics";
      break;

    case "call-process":
      title = "Call Process Graphics";
      break;
    case "analysis":
      title = "Analysis Graphics";
      break;
    case "nettest-graphs":
      title = "NetTest Graphics";
      break;

    case "CustomReport":
      title = "Custom Reports";
      break;

    case "GoogleMap":
      title = "Google Maps";
      break;

    case "LeafletMap":
      title = "Leaflet Maps";
      break;
  }

  return title;
}

export function rsltTypeInAPICall(rsltType: string) {
  let title: string;
  switch (rsltType) {
    case "pesq":
    default:
      title = "VqtData";
      break;
    case "polqa":
      title = "VqtPolqa";
      break;
    case "call-events":
      title = "VquadData";
      break;
    case "vba":
      title = "VbaData";
      break;
    case "fax":
      title = "FaxData";
      break;
    case "audio-delay":
      title = "AudioDelayData";
      break;
    case "emu":
      title = "EmuData";
      break;
    case "nettest":
      title = "NetTestData";
      break;
    case "mobileinfo":
      title = "MobileInfoData";
      break;
    case "vac":
      title = "VacData";
      break;
  }

  return title;
}

export function startAndEndDates(dates:any[]) {

}
